"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _Icon = require("./Icon.consts");

var _Icon2 = require("./Icon.styles");

const _excluded = ["src", "name", "size", "title"];

const Icon = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    src,
    name,
    size = 'small',
    title
  } = _ref,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (name) {
    const external = (0, _Icon.getExternalIcon)(name);

    if (external) {
      return /*#__PURE__*/_react.default.createElement(_Icon2.IconStyled, {
        as: _reactInlinesvg.default,
        size: size,
        src: external,
        title: title,
        className: otherProps.className
      });
    }

    return /*#__PURE__*/_react.default.createElement(_Icon2.IconStyled, (0, _extends2.default)({
      size: size,
      ref: ref
    }, otherProps), title && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("use", {
      href: (0, _Icon.iconUrl)(name)
    }));
  }

  return src ? /*#__PURE__*/_react.default.createElement(_Icon2.IconStyled, {
    as: _reactInlinesvg.default,
    size: size,
    title: title,
    src: src,
    className: otherProps.className
  }) : null;
});

exports.Icon = Icon;
Icon.displayName = 'Icon';
var _default = Icon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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